import {
    createRegisterableComponent,
    ElectionDefinition,
    isElectionFeatureEnabled,
} from '@news-mono/web-common'
import React from 'react'
import { breakpoint } from '../../../__styling'
import {
    DividerContainer,
    LogoContainer,
    LogoLink,
    StyledPicture,
} from './ElectionHomepageLogo.styled'

export interface ElectionHomepageLogoRouteProps {
    electionDefinition: ElectionDefinition
}

/**
 * The election logo shown on the homepage when the election navigation (which
 * carries its own logo) is turned off.
 *
 * Driven by `electionDefinition.logo`, so it follows whichever election
 * `homepage-election-wan-election-id` currently points at.
 */
export const ElectionHomepageLogoRegistration = createRegisterableComponent(
    'election-homepage-logo',
    (props: ElectionHomepageLogoRouteProps, { store }) => {
        const { logo, electionId } = props.electionDefinition

        // Only link through to the landing page when that route is actually on.
        const isLandingPageEnabled = isElectionFeatureEnabled(
            store.getState().toggles,
            electionId,
            'election-landing-page-route',
        )

        const picture = (
            <StyledPicture>
                <source
                    media={breakpoint('sm').replace('@media ', '')}
                    srcSet={logo.desktop}
                />
                <img src={logo.mobile} alt={logo.alt} />
            </StyledPicture>
        )

        return (
            <DividerContainer>
                <LogoContainer as={'h2'}>
                    {isLandingPageEnabled ? (
                        <LogoLink
                            to={`/politics/${electionId}`}
                            aria-label={`Go to the ${logo.alt} page`}
                        >
                            {picture}
                        </LogoLink>
                    ) : (
                        picture
                    )}
                </LogoContainer>
            </DividerContainer>
        )
    },
)
